import BaseSelect from 'lib/BaseSelect';
import usePendoTracking from 'customHooks/usePendoTracking';
import { FilterCreativeTypeProps } from './FilterCreativeType.types';

const FilterCreativeType: React.FC<FilterCreativeTypeProps> = ({ options, selectedValue, onSelect }) => {
  const { getPendoDataId } = usePendoTracking(window.location.pathname);

  return (
    <BaseSelect
      dataTestId="creative-types"
      name="creativeType"
      options={options}
      selectedValue={selectedValue}
      onSelect={onSelect}
      placeholder="Select creative type"
      withPortal={false}
      dataPendoId={getPendoDataId('Creative type filter')}
    />
  );
};

export default FilterCreativeType;
